var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"macroapp macroapp--page-common",class:_vm.pageClasses},[_c(_vm.dynamicComponent,{key:_vm.page,tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }